// extracted by mini-css-extract-plugin
export var slideButton = "paginated-slider-module--slideButton--OYW5Z";
export var slideMeter = "paginated-slider-module--slideMeter--1jQvO";
export var slideButtonActive = "paginated-slider-module--slideButtonActive--zh5w-";